import { useMemo, useState, type ReactNode } from 'react';

import { AppBannerContext } from './appBanner';

export function AppBannerProvider({ children }: { children: ReactNode }) {
  const [topNode, setTopNode] = useState<HTMLElement | null>(null);
  const [overlayNode, setOverlayNode] = useState<HTMLElement | null>(null);
  const [sideNode, setSideNode] = useState<HTMLElement | null>(null);
  const [bottomNode, setBottomNode] = useState<HTMLElement | null>(null);

  const value = useMemo(
    () => ({
      topNode,
      setTopNode,
      overlayNode,
      setOverlayNode,
      sideNode,
      setSideNode,
      bottomNode,
      setBottomNode,
    }),
    [topNode, overlayNode, sideNode, bottomNode],
  );

  return <AppBannerContext.Provider value={value}>{children}</AppBannerContext.Provider>;
}
